import { render, staticRenderFns } from "./meportal.vue?vue&type=template&id=385d9c0d&"
import script from "./meportal.vue?vue&type=script&lang=js&"
export * from "./meportal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports